import apiClient from "@/axios";

export const getApp = async (url) => {
  const response = await apiClient.post("/user/app/process-app-link", {
    url: url,
  });
  return response;
};

export const getAppCountries = async (appId) => {
  const response = await apiClient.post("/user/app/app-countries", {
    appId: appId,
  });
  return response;
};

export const getAppById = async (appId) => {
  const response = await apiClient.post("/user/app/get-app", {
    appId: appId,
  });
  return response;
};

export const getAppByStoreId = async (storeId) => {
  const response = await apiClient.post("/user/app/get-app-by-store-id", {
    storeId: storeId,
  });
  return response;
};

export const processAppByStoreId = async (storeId, country) => {
  const response = await apiClient.post("/user/app/process-app-store-id", {
    storeId: storeId,
    country: country,
  })
  return response;
}

export const preocessAppByStoreId = async (storeId) => {
  const response = await apiClient.post("/user/app/process-app-store-id", {
    storeId: storeId,
  });
  return response;
};

export const importApp = async (appIds, listIds) => {
  const response = await apiClient.post("/user/app/import-app", {
    appIds: appIds,
    listIds: listIds,
  });
  return response;
};